import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
type BadgeColor = 'primary' | 'success' | 'error' | 'warning' | 'info' | 'light' | 'dark';
type BadgeSize = 'xs' | 'sm' | 'md';
type BadgeVariant = 'light' | 'solid';

@Component({
  selector: 'lib-badge',
  imports: [CommonModule, IconComponent],
  template: `
    <span [ngClass]="baseStyles + ' ' + sizeStyles + ' ' + colorStyles">
      @if (startIcon().length > 0) {
        <lib-icon class="mr-1" [name]="startIcon()"></lib-icon>
      }
        <ng-content></ng-content>
      @if (endIcon().length > 0) {
        <lib-icon class="ml-1" [name]="endIcon()"></lib-icon>
      }
    </span>
  `,
  styles: `
    :host{
      @apply w-fit flex
    }
  `
})
export class BadgeComponent {
  color = input<BadgeColor>('light');
  size = input<BadgeSize>('md');
  startIcon = input<string>('');
  endIcon = input<string>('');
  variant = input<BadgeVariant>('solid');


  get baseStyles() {
    return 'inline-flex items-center px-3 py-1 gap-1 rounded-full font-medium text-center justify-center font-title leading-4 truncate';
  }

  get sizeStyles() {
    return {
      xs: 'text-xs',
      sm: 'text-sm',
      md: 'text-md',
    }[this.size()] ?? ['md'];
  }

  get colorStyles() {
    const variants = {
      light: {
        primary:   'bg-brand-50 text-brand-700 dark:bg-brand-500/15 dark:text-brand-400',
        success:
          'bg-success-50 text-success-600 dark:bg-success-500/15 dark:text-success-500',
        error:
          'bg-error-50 text-error-600 dark:bg-error-500/15 dark:text-error-500',
        warning:
          'bg-warning-50 text-warning-600 dark:bg-warning-500/15 dark:text-orange-400',
        info: 'bg-blue-light-50 text-blue-light-500 dark:bg-blue-light-500/15 dark:text-blue-light-500',
        light: 'bg-gray-200 text-gray-700 dark:bg-white/5 dark:text-white/80',
        dark: 'bg-gray-500 text-white dark:bg-white/5 dark:text-white'
      },
      solid: {
        primary: 'bg-brand-500 text-white dark:text-white',
        success: 'bg-success-500 text-white dark:text-white',
        error: 'bg-error-500 text-white dark:text-white',
        warning: 'bg-warning-500 text-white dark:text-white',
        info: 'bg-blue-light-500 text-white dark:text-white',
        light: 'bg-gray-400 dark:bg-white/5 text-white dark:text-white/80',
        dark: 'bg-gray-700 text-white dark:text-white'
      },
    };
    return variants[this.variant()][this.color()] ?? variants[this.variant()]["light"];
  }
}